import { render, staticRenderFns } from "./registered.vue?vue&type=template&id=39c8d008&scoped=true"
import script from "./registered.vue?vue&type=script&lang=js"
export * from "./registered.vue?vue&type=script&lang=js"
import style0 from "./registered.vue?vue&type=style&index=0&id=39c8d008&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c8d008",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WxFollowQr: require('/drone/src/components/WxFollowQr.vue').default,SvgIcon: require('/drone/src/components/SvgIcon/index.vue').default,LoginTemplate: require('/drone/src/components/LoginTemplate/index.vue').default,NewUserCoupon: require('/drone/src/components/NewUserCoupon/index.vue').default})
